import Autocomplete from '@components/Common/Autocomplete.js';
import { UIDiv, UIImage, UISpan } from '@ui';
import { S3URL } from '/config.js';

export default class EmailAutocomplete extends Autocomplete {
  constructor(options = {}) {
    const orgUsers = options.orgUsers || [];
    const currentUserEmail = options.currentUserEmail || '';
    const excludeEmails = options.excludeEmails || [];

    // temporary render function to avoid this binding issue
    const renderUserItem = function (user) {
      const item = new UIDiv();
      item.setClass(
        'flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer',
      );

      // Avatar placeholder or image
      const avatar = new UIDiv();
      if (user.profileImageKey) {
        const img = new UIImage(`${S3URL}${user.profileImageKey}`);
        img.setClass('w-8 h-8 rounded-full object-cover');
        avatar.add(img);
      } else {
        avatar.setClass(
          'w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium',
        );
        avatar.dom.textContent = user.full_name
          ? user.full_name.charAt(0).toUpperCase()
          : user.email.charAt(0).toUpperCase();
      }

      const userInfo = new UIDiv();
      userInfo.setClass('flex flex-col min-w-0');

      const nameSpan = new UISpan(user.full_name || user.email);
      nameSpan.setClass('font-medium text-sm text-gray-900 truncate');

      const emailSpan = new UISpan(user.email);
      emailSpan.setClass('text-xs text-gray-500 truncate');

      userInfo.add(nameSpan);
      if (user.full_name) {
        userInfo.add(emailSpan);
      }

      const roleBadge = new UISpan(
        user.role.charAt(0).toUpperCase() + user.role.slice(1),
      );
      roleBadge.setClass(
        `ml-auto text-xs px-2 py-0.5 rounded-full ${
          user.role === 'admin'
            ? 'bg-purple-100 text-purple-800'
            : 'bg-gray-100 text-gray-800'
        }`,
      );

      item.add(avatar, userInfo, roleBadge);
      return item;
    };

    const originalOnSelect = options.onSelect || (() => {});
    const wrappedOnSelect = user => {
      originalOnSelect(user);
    };

    super({
      ...options,
      onSelect: wrappedOnSelect,
      items: orgUsers,
      excludeItems: excludeEmails,
      placeholder: i18next.t('menubar.share.add_people'),
      allowMultiple: true,
      filterFn: (user, searchText) => {
        const searchLower = searchText.toLowerCase();
        return (
          (user.email.toLowerCase().includes(searchLower) ||
            user.full_name?.toLowerCase().includes(searchLower)) &&
          user.email.toLowerCase() !== currentUserEmail.toLowerCase()
        );
      },
      getItemText: user => user.full_name || user.email,
      renderDropdownItem: renderUserItem,
    });
  }
}
